'use client';

import * as DS from '@aurorasolar/ds';
import Image from 'next/image';

import { TRACKING } from '@/helpers/tracking';
import { AffiliateId } from '@/models';

import { ButtonLink } from './ButtonLink';
import Cabin from './cabin-bg.webp';

type EventName =
  | typeof TRACKING.BLOG_GET_QUOTE
  | typeof TRACKING.LANDING_CLICK_GET_QUOTE
  | typeof TRACKING.NEWS_GET_QUOTE;

type Props = { affiliateId?: AffiliateId; children?: React.ReactNode; ctaLabel?: string; eventName?: EventName };

export const GetStartedCta = ({
  affiliateId,
  children,
  ctaLabel = 'Get estimates',
  eventName = TRACKING.LANDING_CLICK_GET_QUOTE,
}: Props) => {
  return (
    <DS.Flex bg="yellow-200" mt={160}>
      <DS.DarkModeProvider>
        <DS.Flex mt={-10} position="relative" w={{ _: '90%', xl: '100%' }}>
          <Image
            alt="Cabin House"
            fill
            priority
            src={Cabin}
            style={{
              filter: 'brightness(55%)',
              objectFit: 'cover',
              objectPosition: 'center',
            }}
          />
          <DS.Flex
            alignItems="flex-start"
            flexDirection="column"
            gap={4}
            maxW={DS.BorealisTheme.screens.xl}
            mx="auto"
            position="relative"
            px={{ _: 6, md: 8 }}
            py={10}
            zIndex={1}
          >
            <DS.Text as="h2" color="white" text="h6">
              Get Started
            </DS.Text>
            <DS.Text as="h3" color="white" maxW={{ _: '100%', md: '65%' }} text={{ _: 'd1', lg: 'd3' }}>
              Goodbye confusion. Hello sunshine.
            </DS.Text>
            <ButtonLink affiliateId={affiliateId} event={{ name: eventName }} path="/quote-builder" variant="primary">
              {ctaLabel}
            </ButtonLink>
          </DS.Flex>
        </DS.Flex>
      </DS.DarkModeProvider>
      <DS.Flex
        flexDirection={{ _: 'column', md: 'row' }}
        gap={6}
        maxW={DS.BorealisTheme.screens.xl}
        mx={{ _: 0, xl: 'auto' }}
        px={{ _: 6, md: 8 }}
        py={9}
      >
        <DS.Text as="h3" flex={1} text="d1">
          Stay up to speed on the latest at Aurora.
        </DS.Text>
        <DS.Flex alignItems="center" flex={1} justifyContent="center">
          <DS.Flex maxW={{ _: '100%', lg: 'sm' }} w="100%">
            {children}
          </DS.Flex>
        </DS.Flex>
      </DS.Flex>
    </DS.Flex>
  );
};
